import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function BlogPost() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api
      .get(`/blog/${slug}`)
      .then((res) => setPost(res.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) return <main className="pt-40 pb-32 mx-auto max-w-3xl px-6 text-center font-serif text-3xl text-olive">404</main>;
  if (!post) return <main className="pt-40 pb-32 mx-auto max-w-3xl px-6 font-mono text-[11px] tracking-[0.3em] uppercase text-olive-soft">…</main>;

  const title = post[`title_${lang}`] || post.title_es;
  const content = post[`content_${lang}`] || post.content_es;
  const category = post[`category_${lang}`] || post.category_es;

  return (
    <main data-testid="blog-post-page" className="pt-32 sm:pt-40 pb-32">
      <article className="mx-auto max-w-4xl px-6 sm:px-10">
        <Link to="/blog" data-testid="blog-back" className="inline-block font-mono text-[11px] tracking-[0.3em] uppercase text-terracotta mb-10 link-underline">
          ← {t.blog.back}
        </Link>
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-terracotta mb-5">{category}</div>
        <h1 data-testid="post-title" className="h-section-lg text-olive mb-10">
          {title}
        </h1>
        {post.cover_image && (
          <div className="aspect-[16/9] overflow-hidden mb-12">
            <img src={post.cover_image} alt={title} className="w-full h-full object-cover" />
          </div>
        )}
        <div data-testid="post-content" className="font-serif text-xl sm:text-2xl text-olive leading-relaxed whitespace-pre-line">
          {content}
        </div>
        <div className="mt-14 pt-8 border-t border-border font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft">
          Agro Valor Iberica · {new Date(post.created_at).toLocaleDateString(lang === "es" ? "es-ES" : lang === "fr" ? "fr-FR" : "en-GB")}
        </div>
      </article>
    </main>
  );
}
